import React from "react";
import parseWithIcons from "../../utils/parseWithIcons";

const ContenuDynamiqueTexte = ({ data }) => {
  return (
    <div className="dynamic texte">
      {data.texte && <div className="inner">{parseWithIcons(data.texte)}</div>}
    </div>
  );
};

export default ContenuDynamiqueTexte;
